import { notification } from 'antd';

export const setNotification = (type, message) => {
  notification[type]({
    message: message,
    placement: 'bottomLeft',
  });
};
